export default __webpack_public_path__ + "images/XX.27b6cba.png";